import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  HostListener,
  ElementRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GlobalService } from '@core/services/global/global.service';
import { Subject, takeUntil } from 'rxjs';
import { BreadcrumbComponent } from '@shared/components/breadcrumb/breadcrumb.component';
import { DealerSelectComponent } from '@shared/components/dealer-select/dealer-select.component';
import { Router } from '@angular/router';
import { CommentsService } from '@home/src/app/core/services/comments/comments.service';
import { AuthenticationService } from '@home/src/app/core/services/Auth/authservice';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DealerSelectComponent,
    BreadcrumbComponent,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() userName: string | null = null;
  public showLogoutMenu = false;
  public selectedRole: string = 'DLR';
  public isClosed = true;
  public unreadCount: number = 0;
  public showNotificationBadge = false;
  authUser: any = null;
  private readonly destroy$ = new Subject<void>();
  public hideReportsLink: boolean = false;
  public positionCode: string | null = null;

  get unreadNotificationsCount() {
    return this.commentsService.unreadNotificationsCount$ || 0;
  }

  constructor(
    private globalService: GlobalService,
    private commentsService: CommentsService,
    private authService: AuthenticationService,
    private eRef: ElementRef,
    private router: Router,
  ) {}

  ngOnInit() {
    this.commentsService.unreadCount$
      .pipe(takeUntil(this.destroy$))
      .subscribe((count) => {
        this.unreadCount = count;
      });
    this.authService.fincomData$
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => {
        this.authUser = state;
        this.positionCode = this.authUser?.positionCode ?? null;
        this.hideReportsLink = this.positionCode === 'OFM';
      });
    // Subscribe to side menu state
    this.globalService.isSideMenuClosed$
      .pipe(takeUntil(this.destroy$))
      .subscribe((val) => (this.isClosed = val));
  }

  goToReports() {
    this.router.navigate(['/Report-Download']);
  }

  toggleLogoutMenu() {
    this.showLogoutMenu = !this.showLogoutMenu;
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: EventTarget | null) {
    if (!this.eRef.nativeElement.contains(target)) {
      this.showLogoutMenu = false;
    }
  }

  logout() {
    this.showLogoutMenu = false;
    this.router.navigate(['/logout']);
  }

  openComments() {
    this.commentsService.setTitle('All Messages');
    this.commentsService.setSubhect('');
    this.commentsService.setEnableAddComment(false);
    this.commentsService.setType(null);
    this.commentsService.setOpenCommentsPanel(true);
  }

  openNotification() {
    this.commentsService.setNotificationOpen(true);
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
  }
}
